<template>
	<div>
		<HeadIndex></HeadIndex>
		<div ref="height_top" class="product">
			<el-row>
				<el-col :xs="{span: 24, offset: 0}" :sm="{span: 24, offset: 0}" :md="{span: 24, offset: 0}" :lg="{span: 22, offset: 1}" :xl="{span: 20, offset: 2}" class="shop custom-col-20 offset-col-2" v-bind:style="{ height: tableHeight-60 + 'px' }">
					<el-row style="padding:10px 0px 10px 10px">
						<el-col :span="11" class="" style="">
							<el-row>
								<el-col :span="24" class="" style="">
									<el-carousel ref="carousel" v-model="activeIndex" :height="'50vh' " style="text-align: center; border: 3px solid rgb(233, 233, 235);">
										<div style="display: flex;align-items: center; justify-content: center;height: 100%;">
											<span style="color: rgb(139, 139, 139);font-weight: bold;font-size: 0.875rem;">
												用户暂未上传图片
											</span>
										</div>
										<el-carousel-item v-for="(item,key) in data.img" :key="key" height="50vh">
											<el-image :src="item" @click="preview(key)" fit="cover" style="height:100%;width:100%" />
										</el-carousel-item>
									</el-carousel>
								</el-col>
								<!-- 缩略图容器（带左右箭头） -->
								<el-col :span="24" style="margin-top: 10px; position: relative;">
									<el-button icon="ArrowLeft" circle size="mini" style="position: absolute; left: 0; top: 50%; transform: translateY(-50%); z-index: 1;" @click="scrollThumbnails(-1)"></el-button>
									<!-- 缩略图列表（隐藏滚动条） -->
									<div class="thumbnail-container" ref="thumbnailContainer" @scroll="handleThumbnailScroll">
										<div class="thumbnail-item" v-for="(item, key) in data.img" :key="key" :class="{ 'active': key === activeIndex }" @mouseenter="switchToImage(key)">
											<el-image :src="item" fit="cover" style="width: 100%; height: 100%;" />
										</div>
									</div>
									<!-- 右箭头 -->
									<el-button icon="ArrowRight" circle size="mini" style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); z-index: 1;" @click="scrollThumbnails(1)"></el-button>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="13" class="">
							<el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
								<el-tab-pane label="当前详情" name="img">
									<el-row>
										<el-col :span="24" class="">
											<div class="details">
												<div style="margin-top:10px">
													<span class="title">{{data.brand_name}}</span>
													<span class="title" style="margin-left:30px">{{data.model}}</span>
												</div>
												<div class="Price" style="background-color:#fff">
													<el-row class="table">
														<el-col :span="24" class="tbody_bo">
															<el-row>
																<el-col :xs="12" :sm="18" :md="20" :lg="20" :xl="18" class="stock_type_txt_button">
																	<span v-for="item in data.stock_type_txt_list" class="table_content" style="margin-right:20px">
																		<el-button class="A" size="large" text bg v-if="item=='二手' || item=='过保' || item=='包附破损'" style="">{{item}}</el-button>
																		<el-button class="C" size="large" text bg v-else color="#ff8a5c">{{item}}</el-button>
																	</span>
																</el-col>
															</el-row>
														</el-col>
														<el-col :span="24" class="tbody_bo" style="padding-top:0px">
															<el-row>
																<el-col :span="3" class="">
																	<el-row>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title">品牌</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_content ">{{!data.brand_name?'-':data.brand_name}}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="4" class="">
																	<el-row>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title">品名</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_content ">{{!data.name?"-":data.name}}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="7" class="">
																	<el-row>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title">型号</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_content ">{{!data.model?'-':data.model}}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="7" class="">
																	<el-row>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_title_3">订货号</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h">
																			<span class="table_content ">{{!data.order_no?"-":data.order_no}}</span>
																		</el-col>
																	</el-row>
																</el-col>
																<el-col :span="3" class="">
																	<el-row>
																		<el-col :span="24" class="table_content_h" style="text-align: center;">
																			<span class="table_title">数量/单位</span>
																		</el-col>
																		<el-col :span="24" class="table_content_h" style="text-align: center;">
																			<span class="table_content ">{{!data.num?'-':data.num}}/{{ !data.unit?'-':data.unit }}</span>
																		</el-col>
																	</el-row>
																</el-col>
															</el-row>
														</el-col>
														<!-- <el-col :span="24" class="tbody_bo">
													<el-row>
														<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title">数量</span>
															</div>
														</el-col>
														<el-col :span="12" class="">
															<span class="table_content ">{{data.num}}</span>
														</el-col>
													</el-row>
												</el-col>
												<el-col :span="24" class="tbody_bo">
													<el-row>
														<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title_3">联系电话</span>
															</div>
														</el-col>
														<el-col :xs="12" :sm="6" :md="7" :lg="9" :xl="9" class="">
															<span class="table_content ">{{data.user_mobile}}</span>
														</el-col>
														<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title_3">联系人</span>
															</div>
														</el-col>
														<el-col :xs="12" :sm="6" :md="7" :lg="9" :xl="9" class="">
															<span class="table_content ">{{data.user_linkman}}</span>
														</el-col>
													</el-row>
												</el-col>
												<el-col :span="24" class="tbody_bo">
													<el-row>
														<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title">省市</span>
															</div>
														</el-col>
														<el-col :xs="12" :sm="18" :md="20" :lg="20" :xl="20" class="">
															<span class="table_content ">{{data.user_province_name}}{{data.user_city_name}}</span>
														</el-col>
													</el-row>
												</el-col>
												<el-col :span="24" class="tbody_bo_input">
													<el-row>
														<el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" class="">
															<div class="">
																<span class="table_title">
																	<el-input-number v-model="num" :min="1" :max="data.num" />
																</span>
															</div>
														</el-col>
														<el-col :xs="12" :sm="12" :md="16" :lg="18" :xl="18" class="">
															<span class="table_content ">
																<el-button type="danger">加入购物车</el-button>
															</span>
														</el-col>
													</el-row>
												</el-col> -->
													</el-row>
												</div>
											</div>
										</el-col>
										<el-col :span="24" class="">
											<div class="details details_Price" style="margin-left:0px">
												<!-- <div>
											<span class="button" style="">
												
											</span>
										</div> -->
												<div class="Price">
													<el-row class="table" style="margin-bottom:10px">
														<!-- <el-col :span="24" class="tbody" style="margin-left:25px">
													<el-row>
														<el-col :xs="12" :sm="8" :md="6" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title_3">列表价</span>
															</div>
														</el-col>
														<el-col :xs="12" :sm="16" :md="18" :lg="21" :xl="21" class="">
															<span class="table_content">{{data.price}}</span>
														</el-col>
													</el-row>
												</el-col> -->
														<!-- <el-col :span="24" class="tbody"  style="margin-left:25px">
													<el-row>
														<el-col :xs="12" :sm="8" :md="6" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title">折扣</span>
															</div>
														</el-col>
														<el-col :xs="12" :sm="16" :md="18" :lg="21" :xl="21" class="">
															<span class="table_content">{{data.tsw_discount}}</span>
														</el-col>
													</el-row>
												</el-col> -->
														<el-col :span="24" class="tbody" style="margin-bottom: 10px;margin-left:25px">
															<el-row>
																<el-col :xs="12" :sm="8" :md="6" :lg="3" :xl="3" class="titlePrice">
																	<div class="">
																		<el-tooltip placement="top">
																			<template #content>
																				<p>此信息由用户提供</p>
																				<p>列表价格：{{data.price}}</p>
																				<p>折扣：{{data.tsw_discount}}</p>
																			</template>
																			<span class="table_title">单价</span>
																		</el-tooltip>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="16" :md="18" :lg="21" :xl="21" class="">
																	<el-tooltip placement="top">
																		<template #content>
																			<p>此信息由用户提供</p>
																			<p>列表价格：{{data.price}}</p>
																			<p>折扣：{{data.tsw_discount}}</p>
																		</template>
																		<span class="table_content table_Price">{{data.tsw_price}}</span>
																	</el-tooltip>
																</el-col>
															</el-row>
														</el-col>
													</el-row>
												</div>
											</div>
										</el-col>
										<el-col :span="24" class="">
											<div class="details " style="margin-left:0px">
												<!-- <div>
											<span class="button" style="">
												
											</span>
										</div> -->
												<div class="Price" style="background-color:#fff">
													<el-row class="table">
														<el-col :span="24" class="tbody" style="margin-left:25px">
															<el-row>
																<el-col :xs="12" :sm="8" :md="6" :lg="3" :xl="3" class="">
																	<div class="">
																		<span class="table_title_3">备注</span>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="16" :md="18" :lg="21" :xl="21" class="">
																	<span class="table_content">{{data.remark}}</span>
																</el-col>
															</el-row>
														</el-col>
													</el-row>
												</div>
											</div>
										</el-col>
										<el-col :span="24" class="">
											<div class="details">
												<div>
													<span class="" style="color:#ff8a5c;padding-left: 25px;font-size:30px">联系方式</span>
													<!-- <span class="button" style="float: right;">
										<el-button type="success" size="small" plain>{{data.stock_type_txt}}</el-button>
									</span> -->
												</div>
												<div class="Price" style="background-color:#fff;color:#8B8B8B">
													<el-row class="table">
														<!-- <el-col :span="24" class="tbody_bo">
													<el-row>
														<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
															<div class="">
																<span class="table_title">数量</span>
															</div>
														</el-col>
														<el-col :span="12" class="">
															<span class="table_content ">{{data.num}}</span>
														</el-col>
													</el-row>
												</el-col> -->
														<el-col :span="24" class="tbody_bo">
															<el-row>
																<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
																	<div class="">
																		<span class="table_title_3">联系电话</span>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="6" :md="7" :lg="9" :xl="9" class="">
																	<span class="table_content ">{{!data.user_mobile?'-':data.user_mobile}}</span>
																</el-col>
																<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
																	<div class="">
																		<span class="table_title_3">联系人</span>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="6" :md="7" :lg="9" :xl="9" class="">
																	<span class="table_content ">{{!data.user_linkman?'-':data.user_linkman}}</span>
																</el-col>
															</el-row>
														</el-col>
														<el-col :span="20" class="tbody_bo">
															<el-row>
																<el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3" class="">
																	<div class="">
																		<span class="table_title">省市</span>
																	</div>
																</el-col>
																<el-col :xs="12" :sm="18" :md="20" :lg="20" :xl="20" class="">
																	<span class="table_content ">{{!data.user_province_name?'-':data.user_province_name}}{{!data.user_city_name?'-':data.user_city_name}}</span>
																</el-col>
															</el-row>
														</el-col>
														<el-col :span="4" class="tbody_bo">
												<div style="display: flex; justify-content: center; align-items: center; height: 100%;">
													<el-icon size="28" @click.stop="chat_click(data.id)"
														style="color:var(--el-color-primary);  cursor: pointer;">
														<ChatDotSquare />
													</el-icon>
												</div>
											</el-col>
													</el-row>
												</div>
											</div>
										</el-col>
									</el-row>
								</el-tab-pane>
								<el-tab-pane label="疑似关联" name="list">
								<template #label>
									
									<span v-if="data.associate.length">
										<el-badge :max="10000000" :value="data.associate.length" class="item">
										<span>疑似关联</span>
									</el-badge>
									</span>
									<span v-else>
										<span>疑似关联</span>
									</span>
								</template>

									<div class="goodDetails_name_img">
										<div class="goodDetails_name_img_div" style="height:62vh;overflow: auto;">
											<div style="">
												<el-descriptions title="" border>
													<el-descriptions-item label-class-name="my-label" class-name="my-content" label-width="11%" width="22%" label="品牌">{{data.brand_name}}</el-descriptions-item>
													<el-descriptions-item label-class-name="my-label" class-name="my-content" label-width="11%" width="22%" label="型号">{{data.model}}</el-descriptions-item>
													<el-descriptions-item label-class-name="my-label" class-name="my-content" label-width="11%" width="22%" label="订货号">{{data.order_no}}</el-descriptions-item>
													
												</el-descriptions>
											</div>
											<div style="margin-top:10px" v-for="(item,index) in data.associate">
												<el-descriptions title="" border>
													<el-descriptions-item label-width="11%" width="22%" label="品牌">{{item.brand_name}}</el-descriptions-item>
													<el-descriptions-item label-width="11%" width="22%" label="型号">{{item.model}}</el-descriptions-item>
													<el-descriptions-item label-width="11%" width="22%" label="订货号">{{item.order_no}}</el-descriptions-item>
													<el-descriptions-item class-name="remark_descriptions" label-width="11%" label="备注"><span v-html="item.remark.replace(/\n/g, '&lt;br&gt;')"></span></el-descriptions-item>
												</el-descriptions>
											</div>
										</div>
									</div>
								</el-tab-pane>
							</el-tabs>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
		<el-image-viewer v-if="showPreview" :url-list="srcList" show-progress :initial-index="srcList_index" @close="showPreview = false" />
		<chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
	</div>
</template>
<script>
import '../../assets/product/index.css' //优化表格样式
import { ElMessage, ElMessageBox } from 'element-plus'
import { ChatDotSquare } from '@element-plus/icons-vue'
import HeadIndex from '../public/HeadIndex';
import chat from '../public/chat';
export default {
	name: 'product',
	components: {
		HeadIndex,
		chat,
		ChatDotSquare
	},
	data() {

		return {
			activeName: 'img',
			activeIndex: 0, // 当前激活的轮播图索引
			hasScrollLeft: false, // 是否可以向左滚动
			hasScrollRight: false, // 是否可以向右滚动
			num: 1,
			tableHeight: '',
			srcList_index: '',
			srcList: [],
			showPreview: false,
			data: {associate:[]},
			id: '',
			chat_info: false,
		}
	},
	props: [],

	updated() {

	},


	mounted() {
		this.handleThumbnailScroll();
	},

	activated() {

	},
	created() {

		this.id = this.$route.query.id
		this.search();
		this.tableHeight_fun();
	},
	watch: {

	},
	methods: {
		handleClick() {

		},
		// 鼠标移入缩略图，切换到对应轮播图
		switchToImage(key) {
			this.activeIndex = key;
			if (this.$refs.carousel) {
				this.$refs.carousel.setActiveItem(key);
			}
		},

		// 滚动缩略图（1：向右，-1：向左）
		scrollThumbnails(direction) {

			if (direction === 1) {
				// 向右滚动
				if (this.data.img.length == (this.activeIndex + 1)) {
					this.activeIndex = 0
				} else {
					this.activeIndex = this.activeIndex + 1;
				}
				console.log(this.activeIndex)
			} else {
				// 向左滚动
				if (this.activeIndex === 0) {
					this.activeIndex = this.data.img.length - 1
				} else {
					this.activeIndex = this.activeIndex - 1;
				}
			}

			this.$refs.carousel.setActiveItem(this.activeIndex);
			// 同步更新轮播图索引

		},

		// 监听缩略图容器滚动，判断是否可以继续滚动
		handleThumbnailScroll() {
			const container = this.$refs.thumbnailContainer;
			if (!container) return;

			const { scrollLeft, scrollWidth, clientWidth } = container;
			// 可以向左滚动：scrollLeft > 0
			this.hasScrollLeft = scrollLeft > 10; // 留10px缓冲，避免边界判断不准
			// 可以向右滚动：scrollLeft + clientWidth < scrollWidth
			this.hasScrollRight = scrollLeft + clientWidth < scrollWidth - 10;
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
				this.tableHeight = (this.tableHeight > 550) ? this.tableHeight : 550
			})
		},
		preview(key) {
			this.srcList = [];
			this.srcList_index = key
			this.showPreview = true;
			var obj = this;
			this.data.img.forEach(function(item) {
				obj.srcList.push(item)
			})
		},
		async search() {
			var search = { id: this.id }
			await this.$axios.post('/api/yunsys.Storage/getonestorage', search).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					if (res.data.stock_type_txt) {
						res.data.stock_type_txt_list = res.data.stock_type_txt.split("、");
					} else {
						res.data.stock_type_txt_list = []
					}

					res.data.real_money = obj.$bn.multiply(res.data.sur_num, res.data.real_price, 4);
					res.data.real_price = obj.$bn.multiply(res.data.real_price, 1, 4);
					res.data.tsw_price = obj.$bn.multiply(res.data.tsw_price, 1, 4);
					res.data.tsw_discount = obj.$bn.divide(res.data.tsw_price, res.data.price, 4)
					this.data = res.data;
					document.title = this.data.model;

				})
				.catch(err => {
					console.log(err)
					return ElMessage({
						message: '无此商品',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		closeChat() { this.chat_info = false },
		async chat_click(id) {
			await this.$axios.post('/api/yunsys.storage/addchat', { id }).then(res => {
				const d = res.data
				if (d.code !== 0) return ElMessage.error(d.msg)
				this.chat_info = false
				this.$nextTick(() => {
					this.chat_info = true
					this.$nextTick(() => {
						if (this.$refs.chat) {
							this.$refs.chat.dialogTableVisible = true
							this.$refs.chat.pitch_id = d.data.data
							this.$refs.chat.admin_pitch_id = d.data.data
							this.$refs.chat.search()
						}
					})
				})
			}).catch(() => ElMessage.error('系统错误'))
		}
	}
}
</script>
<style lang="less" scoped>
/* 缩略图容器样式 */
.thumbnail-container {
	display: flex;
	gap: 10px;
	/* 缩略图之间的间距 */
	padding: 10px 40px;
	/* 左右留出箭头位置 */
	overflow-x: auto;
	/* 允许水平滚动 */
	white-space: nowrap;
	/* 防止换行 */
	scrollbar-width: none;
	/* 隐藏Firefox滚动条 */
}

/* 隐藏Chrome/Safari滚动条 */
.thumbnail-container::-webkit-scrollbar {
	display: none;
}

/* 缩略图项样式 */
.thumbnail-item {
	width: 100px;
	/* 缩略图宽度 */
	height: 80px;
	/* 缩略图高度 */
	border-radius: 9px;
	cursor: pointer;
	transition: all 0.3s ease;
	border: 2px solid transparent;
	/* 默认透明边框 */
}

/* 激活的缩略图高亮样式 */
.thumbnail-item.active {
	border-color: #ff8a5c;
	/* 与轮播图边框颜色一致 */
	box-shadow: 0 0 5px rgba(255, 138, 92, 0.5);
	transform: scale(1.05);
	/* 轻微放大效果 */
}

:deep(.el-tabs__item.is-active) {
	// background-color: #f56c6c; /* 选中标签的背景颜色 */
	//border-color: #f56c6c; /* 选中标签的边框颜色 */
	color: #ff8a5c;
	/* 选中标签的文字颜色 */
}

:deep(.el-tabs__active-bar) {
	background-color: #ff8a5c;
	/* 选中标签下方的横线颜色 */
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}

:deep(.el-input-group__append) {

	background: #ff8a5c;
}
:deep(.remark_descriptions){
	height: 80px;
}
:deep(.el-tabs__nav-scroll) {
	overflow: hidden;
	margin-left: 20px;
}

:deep(.product .el-button > span) {
	font-size: 19.5px;
}
.thumbnail-item :deep(.el-image) {
	border: 0px solid #eee;
}
.Price tr {
	//height: calc(var(--tableHeight) / 8);
}

.logo_m {
	margin-top: 50px;
	height: 20px
}

.Page_heading {
	margin-top: 0px;

}

.stock_type_txt_button .el-button {
	margin-right: 5px;
	font-size: 0.70rem !important;
	padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
	color: #ff8a5c;
	background-color: rgb(255, 240, 228) !important;
}
:deep(.my-label) {
  background: #ff8a5c  !important;
}
:deep(.my-content) {
  background: #ff8a5c  !important;
}
.stock_type_txt_button .B {
	color: red;
	background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205);
	background-color: rgb(223, 255, 251) !important;
}

.stock_type_txt {
	line-height: 22px
}
</style>